var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import CountryAndDocumentSelection from './Screens/CountryAndDocumentSelection';
import LoadDocuments from './Screens/LoadDocuments';
import { deleteUploadedDocumentById, uploadUserDocuments, } from '../../../Services/methods/verifications';
import { getActualFilesIds, getDocSubTypesByDocType, getKYCInfo, Screens, } from './utils';
import { SumSubWidgetScreen } from './Screens/SumSubWidgetScreen';
import { useLocationData } from '../../Contexts/LocationDataContext';
export var KYCUserVerification = function () {
    var userLocation = useLocationData();
    var _a = useState(Screens.SET_DOCUMENTS), currentScreen = _a[0], setCurrentScreen = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), countryList = _c[0], setCountryList = _c[1];
    var _d = useState(), currentCountry = _d[0], setCurrentCountry = _d[1];
    var _e = useState([]), docTypesList = _e[0], setDocTypesList = _e[1];
    var _f = useState(), currentDocType = _f[0], setCurrentDocType = _f[1];
    var _g = useState(false), onlySumSub = _g[0], setOnlySumSub = _g[1];
    var _h = useState(), token = _h[0], setToken = _h[1];
    var _j = useState([
        undefined,
        undefined,
    ]), filesIds = _j[0], setFilesIds = _j[1];
    var _k = useState([]), fileErrors = _k[0], setFileErrors = _k[1];
    var _l = useState([]), fileWarnings = _l[0], setFileWarnings = _l[1];
    var _m = useState(new Map()), clientReviewResult = _m[0], setClientReviewResult = _m[1];
    useEffect(function () {
        getKYCInfo()
            .then(function (_a) {
            var countries = _a.countries, docTypes = _a.docTypes, token = _a.token, currentCountry = _a.currentCountry, currentDocType = _a.currentDocType, identityStepExist = _a.identityStepExist, imageReviewClientResult = _a.imageReviewClientResult, currentScreen = _a.currentScreen, submittedDocsIds = _a.submittedDocsIds;
            var userCountry = countries.find(function (country) { return country.code === (userLocation === null || userLocation === void 0 ? void 0 : userLocation.countryCode); });
            setOnlySumSub(!identityStepExist);
            setClientReviewResult(imageReviewClientResult);
            setDocTypesList(docTypes);
            setCurrentDocType(currentDocType || docTypes[0]);
            setCountryList(countries);
            setCurrentCountry(currentCountry || userCountry || countries[0]);
            setCurrentScreen(currentScreen);
            setToken(token);
            if (submittedDocsIds) {
                setFilesIds(submittedDocsIds);
            }
        })
            .finally(function () { return setLoading(false); });
    }, [userLocation]);
    var onlyOneDocSide = currentDocType
        ? getDocSubTypesByDocType(currentDocType).length === 1
        : false;
    var loadDocument = useCallback(function (file, subtype) { return __awaiter(void 0, void 0, void 0, function () {
        var countryCode, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setFileErrors(function (prevState) { return (prevState.length === 0 ? prevState : []); });
                    setFileWarnings(function (prevState) { return (prevState.length === 0 ? prevState : []); });
                    countryCode = currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.code;
                    return [4 /*yield*/, uploadUserDocuments(file, countryCode, currentDocType, onlyOneDocSide ? undefined : subtype)];
                case 1:
                    res = _a.sent();
                    if ((res === null || res === void 0 ? void 0 : res.code) && (res === null || res === void 0 ? void 0 : res.description)) {
                        throw new Error(res.description);
                    }
                    setFilesIds(function (files) {
                        var newArr = __spreadArray([], files, true);
                        newArr[subtype === 'BACK_SIDE' ? 1 : 0] = res.imageId;
                        return newArr;
                    });
                    if (res.errors) {
                        setFileErrors(res.errors);
                    }
                    if (res.warnings) {
                        setFileWarnings(res.warnings);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.code, currentDocType, onlyOneDocSide]);
    var removeDocument = useCallback(function (fileId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deleteUploadedDocumentById(fileId)];
                case 1:
                    _a.sent();
                    setFilesIds(function (files) {
                        return files.map(function (item) { return (item === fileId ? undefined : item); });
                    });
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var incrementScreen = useCallback(function () {
        setCurrentScreen(function (screen) { return screen + 1; });
    }, []);
    var decrementScreen = useCallback(function () {
        setCurrentScreen(function (screen) { return screen - 1; });
    }, []);
    var handleOpenSunSab = useCallback(function (token) {
        setToken(token);
        setCurrentScreen(Screens.SUM_SUB);
    }, []);
    var isDocumentLoaded = getActualFilesIds(filesIds, currentDocType).some(function (item) { return item !== undefined; });
    var isEveryDocumentLoaded = getActualFilesIds(filesIds, currentDocType).every(function (item) { return item !== undefined; });
    var renderCurrentScreen = useCallback(function () {
        switch (currentScreen) {
            case Screens.SET_DOCUMENTS:
                return (_jsx(CountryAndDocumentSelection, { blocked: isDocumentLoaded, loading: loading, onClick: incrementScreen, country: currentCountry, countries: countryList, onChangeCountry: setCurrentCountry, currentDocType: currentDocType, docTypesList: docTypesList, onChangeDocument: setCurrentDocType }));
            case Screens.LOAD_DOCUMENTS:
                if (!(currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.code)) {
                    setCurrentScreen(Screens.SET_DOCUMENTS);
                    return;
                }
                return (_jsx(LoadDocuments, { fileErrors: fileErrors, fileWarnings: fileWarnings, filesIds: filesIds, loadDocument: loadDocument, removeDocument: removeDocument, countryCode: currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.code, onNextClick: handleOpenSunSab, onBackClick: decrementScreen, currentDocType: currentDocType, clientReviewResult: clientReviewResult, onlyOneDocSide: onlyOneDocSide, documentsLoaded: isEveryDocumentLoaded }));
            case Screens.SUM_SUB:
                if (!(currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.code) || !token) {
                    setCurrentScreen(Screens.SET_DOCUMENTS);
                    return;
                }
                return (_jsx(SumSubWidgetScreen, { token: token, onBackClick: onlySumSub ? undefined : decrementScreen, country: currentCountry.code }));
        }
    }, [
        currentScreen,
        isDocumentLoaded,
        loading,
        incrementScreen,
        currentCountry,
        countryList,
        currentDocType,
        docTypesList,
        fileErrors,
        fileWarnings,
        filesIds,
        loadDocument,
        removeDocument,
        handleOpenSunSab,
        decrementScreen,
        clientReviewResult,
        onlyOneDocSide,
        isEveryDocumentLoaded,
        token,
        onlySumSub,
    ]);
    return _jsx(_Fragment, { children: renderCurrentScreen() });
};
